import { render, staticRenderFns } from "./FormSelectControlSize.vue?vue&type=template&id=3e504f0c&"
import script from "./FormSelectControlSize.vue?vue&type=script&lang=js&"
export * from "./FormSelectControlSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports